$(document).on('turbolinks:load', () => {
	$('.spNavBtn').on("click", function(){
		$(this).toggleClass('open');
		$('.spNav').toggleClass('open');
	});
});